import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type EditActionIconPropsType = {
  onClick: () => void;
};

export const EditActionIcon: React.FC<EditActionIconPropsType> = ({
  onClick,
}) => {
  const { t } = useTranslation('common');

  return (
    <ActionIcon
      color="blue"
      variant="outline"
      onClick={onClick}
      data-testid="edit-action-icon"
      role="button"
      aria-label={t('ACTIONS.EDIT')}
    >
      <FontAwesomeIcon icon={faPen} />
    </ActionIcon>
  );
};
